import { Action } from '@check-list/app/classes/models/action.model';

const translPath = 'menu.';

export const MenuItemsData = {
  DELETE: new Action('delete', `${translPath}delete`),
  UPLOAD: new Action('upload', `${translPath}upload`),
  OPEN_STORAGE: new Action('folder-open', `${translPath}openStorage`),
  SHOW: new Action('info-circle'),
  UPDATE: new Action('edit')
};
